const INITIAL_STATE = {};

function fetchPageInProgress(pageId, state, timestamp) {
  const newState = {
    ...state,
  };
  newState[pageId] = Object.assign(newState[pageId] || {}, {
    fetchingInProgressSince: timestamp,
  });

  return newState;
}

function fetchPageSuccessful(page, pageId, state, timestamp) {
  const newState = {
    ...state,
  };
  newState[pageId] = Object.assign(newState[pageId] || {}, {
    ...page,
    didInvalidate: false,
    fetchingInProgressSince: null,
    lastSuccessfulFetch: timestamp,
  });
  return newState;
}

function fetchPageFailed(pageId, reason, state, timestamp) {
  const newState = {
    ...state,
  };
  newState[pageId] = Object.assign(newState[pageId] || {}, {
    fetchingInProgressSince: null,
    lastFailedFetch: timestamp,
    lastErrorMessage: reason,
  });

  return newState;
}

module.exports = function LandingPageReducer(
  state = INITIAL_STATE,
  action = {},
) {
  switch (action.type) {
    case 'SET_API_URL':
      return INITIAL_STATE;
    case 'SET_LANGUAGE':
    case 'INVALIDATE_LANDING_PAGES':
      return Object.keys(state).reduce((acc, key) => {
        acc[key] = Object.assign(state[key], { didInvalidate: true });
        return acc;
      }, {});
    case 'FETCH_LANDING_PAGE_IN_PROGRESS':
      return fetchPageInProgress(action.pageId, state, action.timestamp);
    case 'FETCH_LANDING_PAGE_SUCCESSFUL':
      return fetchPageSuccessful(
        action.page,
        action.pageId,
        state,
        action.timestamp,
      );
    case 'FETCH_LOOTS_FAILED':
      return fetchPageFailed(
        action.pageId,
        action.reason,
        state,
        action.timestamp,
      );
    default:
      return state;
  }
};
